import { AppConfig } from '@App/Main.types';
import { Config } from '@Config/Config';
import React from 'react';

// @ts-ignore
export const AppConfigContext = React.createContext<AppConfig>(Config);
